import { LucideIcon } from "lucide-react";

interface InfoCardProps {
  icon: LucideIcon;
  heading: string;
  value: string;
}

export default function InfoCard({
  icon: Icon,
  heading,
  value,
}: InfoCardProps) {
  return (
    <div className="flex-1 flex flex-col gap-1 p-4 rounded-[10px] border border-[#e5e5e5] bg-[#FDFDFD]">
      <div className="flex gap-1 h-4 items-center">
        <Icon size={16} className="text-[var(--color-black-7)]" />
        <p className="font-normal text-[var(--color-black-7)] text-[12px] tracking-[-0.24px] leading-normal">
          {heading}
        </p>
      </div>
      <p className="font-medium text-[#171717] text-[14px] tracking-[-0.56px] leading-normal">
        {value}
      </p>
    </div>
  );
}
